module.exports = __webpack_public_path__ + "img/bottom-bj.c1911fd2.jpg";